import ClaimENSPage from './ClaimENSPage.container'
export default ClaimENSPage
